import React, { useEffect, useState } from 'react';
import SingleAccordion from '../components/Accordion/singleAccordion';
import GroupCardProductSale from '../components/CardProductSale/N3BundlesProduct';
import FooterComp from '../components/Footer/Footer';
import HeaderComp from '../components/Header/Header';
import ProductBadgeWidget from '../components/ProductBadgeWidget/ProductBadgeWidget';
import BundlePopup from '../components/BundlePopup/BundlePopUpElite';
import config from '../config/config';
import SetHeaders from '../config/SetHeaders';
import seo from '../config/seo';
import Head from 'next/head';
import axios from 'axios';

// test for vercel

const BundleContainer = ({ Header, Body, Footer, response, res }: any) => {
  const [state, setstate]: any = useState({
    isClosed: false,
  });

  // const [productdetail, setproductdetail] = useState();
  // const [productbadges, setproductbadges] = useState();
  const [bundle, setBundle]: any = useState();

  // useEffect(() => {
  //   // setproductdetail(res);
  //   // setproductbadges(res.AdditionalInfo);
  // }, [])
  // setproductdetail(res);
  // setproductbadges(res.AdditionalInfo);
  const components = (typeName: any, compData: any, key: any) => {
    switch (typeName) {
      case 'n3elite.bundle-card-widget':
        return (
          <GroupCardProductSale
            productdetail={res}
            data={compData}
            key={key}
            onCloseHandler={(id: number) => {
              setBundle(id);
              onTogglerHandler();
            }}
          />
        );
      default:
        return null;
    }
  };

  const onTogglerHandler = () => {
    setstate({ ...state, isClosed: !state.isClosed });
  };

  return (
    <React.Fragment>
      {response && !response.Seo && (
        <Head>
          <title>{seo.n3Bundle}</title>
        </Head>
      )}
      {response && <SetHeaders HEADERS={response} />}
      {Header && <HeaderComp HeaderValue={Header} />}
      <div className="app-body">
        {Body &&
          Body.map((data: any, i: number) => {
            return components(data.__component, data, i);
          })}
        {state.isClosed && <BundlePopup data={bundle} onCloseHandler={onTogglerHandler} />}
      </div>
      {Footer && <FooterComp data={Footer} />}
    </React.Fragment>
  );
};

export async function getStaticProps() {
  const body = await axios.get(config.endpoints.bundle)
  const subBody = await axios.get(`${config.endpoints.products}/${body.data.product}`)
  const props = axios.all([body, subBody]).then(
    axios.spread((...result) => {
      let response = result[0].data
      let res = result[1].data

      return {
        props: {
          Header: response.Header,
          Body: response.Body,
          Footer: response.Footer.Footer,
          response: response,
          res: res
        },
        revalidate: 3600
      }
    }
    ))
  return props
}

export default BundleContainer
